export const SELECTION_CHANGED_EVENT = 'selection-changed' as const;

export interface SelectionChangedDetail {
  ids: ReadonlyArray<string>;
}
